import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["date", "disableTooltip", "tooltipFormat", "className"];
import * as React from 'react';
import { differenceInMinutes, format as formatDate, formatDistance } from 'date-fns';
import cn from 'classnames';
import { Text } from '../../type/text';
import { Tooltip } from '../../tooltip';
export var RelativeDate = function RelativeDate(props) {
  var date = props.date,
    _props$disableTooltip = props.disableTooltip,
    disableTooltip = _props$disableTooltip === void 0 ? false : _props$disableTooltip,
    _props$tooltipFormat = props.tooltipFormat,
    tooltipFormat = _props$tooltipFormat === void 0 ? 'MMM dd, yyyy H:mm a' : _props$tooltipFormat,
    className = props.className,
    textProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(new Date()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    now = _React$useState2[0],
    setNow = _React$useState2[1];
  React.useEffect(function () {
    if (differenceInMinutes(date, now) > 45) return;
    var intervalId = window.setInterval(function () {
      setNow(new Date());
    }, 1000 * 60);
    return function clearInterval() {
      window.clearInterval(intervalId);
    };
  }, [date]);
  return React.createElement(Text, _extends({}, textProps, {
    className: cn('relative-date', className)
  }), React.createElement(Tooltip, {
    isDisabled: disableTooltip,
    content: formatDate(date, tooltipFormat),
    referenceTagName: "span",
    hoverOpenDelay: 600
  }, formatDistance(date, now, {
    addSuffix: true
  })));
};
RelativeDate.displayName = 'RelativeDate';
RelativeDate.defaultProps = {};